import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

if (!window.storage) {
  window.storage = {
    get: async (key, shared) => {
      try {
        const val = localStorage.getItem((shared ? 's_' : '') + key);
        return val ? { key, value: val, shared } : null;
      } catch { return null; }
    },
    set: async (key, value, shared) => {
      try {
        localStorage.setItem((shared ? 's_' : '') + key, value);
        return { key, value, shared };
      } catch { return null; }
    },
    delete: async (key, shared) => {
      try {
        localStorage.removeItem((shared ? 's_' : '') + key);
        return { key, deleted: true, shared };
      } catch { return null; }
    },
    list: async (prefix, shared) => {
      try {
        const keys = Object.keys(localStorage)
          .filter(k => k.startsWith((shared ? 's_' : '') + (prefix || '')))
          .map(k => k.replace(shared ? 's_' : '', ''));
        return { keys, prefix, shared };
      } catch { return { keys: [] }; }
    }
  };
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App /></React.StrictMode>);

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then(() => console.log('SW registered'))
      .catch(() => {});
  });
}
